import { ComponentFactoryResolver } from '@angular/core';
import { Observer } from 'rxjs';

export enum ModalSize {
    SM = 'sm',
    MD = 'md',
    LG = 'lg',
    XL = 'xl',
    bash = 'remote-bash'
}

export class ModalConfigurationModel {
    title?: string;
    titleIcon?: string;
    modalSize?: ModalSize;
    modalCustomClass?: string;
    showBackground?: boolean;

    constructor() {
        this.showBackground = true;
        this.modalSize = ModalSize.SM;
    }
}

export class ModalModel {
    componentFactoryResolver: ComponentFactoryResolver;
    component: any;
    data: any;
    content?: any;
    public modalConfiguration?: ModalConfigurationModel;
    observable?: Observer<any>;
}
